import React from 'react';
import { Table } from 'tea-component';
import type { Moment } from 'moment';
import SelectedReportItem from '../SelectedReportItem';
import ParentDateFilter from '../ParentDateFilter';
import { IntelligenceReportDataInfo, IReportDateRanges } from '../../type';
import './index.scss';
import classNames from 'classnames';

const { draggable } = Table.addons;

interface SelectedReportsTableProps {
  /** 已选报告列表 */
  selectedReports: IntelligenceReportDataInfo[];
  /** 是否英文 */
  isEn: boolean;
  /** 是否展示父级日期筛选器 */
  showParentDateFilter?: boolean;
  /** 父级日期筛选器标签（英文） */
  topDateFilterLabelEn?: string;
  /** 父级日期筛选器标签（中文） */
  topDateFilterLabelCn?: string;
  /** 父级日期范围 */
  parentDateRange?: [Moment, Moment];
  /** 各报告日期范围 */
  reportDateRanges?: IReportDateRanges;
  /** 父级日期变化 */
  onParentDateChange?: (value: [Moment, Moment]) => void;
  /** 拖拽排序回调 */
  onDragEnd: (records: IntelligenceReportDataInfo[]) => void;
  /** 移除报告回调 */
  onRemove: (data: IntelligenceReportDataInfo) => void;
  /** 日期变化回调 */
  onDateChange: (data: IntelligenceReportDataInfo, startTime: string, endTime: string) => void;
}

/**
 * 已选报告表格组件
 * 支持拖拽排序
 */
const SelectedReportsTable: React.FC<SelectedReportsTableProps> = ({
  selectedReports,
  isEn,
  showParentDateFilter = false,
  topDateFilterLabelEn,
  topDateFilterLabelCn,
  parentDateRange,
  reportDateRanges = {},
  onParentDateChange,
  onDragEnd,
  onRemove,
  onDateChange,
}) => {
  const isEmpty = selectedReports.length === 0;

  return (
    <div className="dbh-selected-reports-table-wrap">
      {showParentDateFilter && parentDateRange && (
        <ParentDateFilter
          isEn={isEn}
          labelEn={topDateFilterLabelEn}
          labelCn={topDateFilterLabelCn}
          value={parentDateRange}
          onChange={onParentDateChange}
        />
      )}
      {isEmpty ? (
        <div className="dbh-selected-reports-table-empty">
          {isEn ? 'No reports selected' : '暂无选中报告'}
        </div>
      ) : (
        <Table
          records={selectedReports}
          recordKey="resource_id"
          hideHeader
          className={classNames('dbh-selected-reports-table', {
            'dbh-selected-reports-table--with-parent-date-filter': showParentDateFilter,
          })}
          columns={[
            {
              key: 'report',
              header: '',
              render: (record: IntelligenceReportDataInfo) => (
                <SelectedReportItem
                  data={record}
                  dateRange={reportDateRanges[record.resource_id]}
                  onRemove={onRemove}
                  onDateChange={onDateChange}
                />
              ),
            },
          ]}
          addons={[
            draggable({
              onDragEnd,
            }),
          ]}
        />
      )}
    </div>
  );
};

export default SelectedReportsTable;
